import { getApiBaseUrl, getApiClient } from "./serviceconfig";
import { appendQueryParams } from "../utils/listViewDateRanges";

var apiBaseUrl = getApiBaseUrl();

export async function getPendingCubeTestReports(cookies, plantId, ageDays, dateRange = {}) {
  const params = new URLSearchParams({
    plant_id: plantId,
    age_days: ageDays,
  });
  if (dateRange.fromDate) {
    params.append('from_date', dateRange.fromDate);
  }
  if (dateRange.uptoDate) {
    params.append('upto_date', dateRange.uptoDate);
  }
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/cube_test_report/pending/?${params.toString()}`)
    .then((response) => response.data);
}

export async function getCubeTestReportNumber(cookies, plantId, csrDate) {
  console.log(plantId + "plantId" + csrDate + "csrDate")
  let url = `${apiBaseUrl}/cube_test_report/cube_test_report_number/`;
  if (csrDate && plantId) {
    url = url + `?plant_id=${plantId}&cube_test_report_date=${csrDate}`;
  }
  else {
    url = url + `?plant_id=${plantId}`;
  }
  return getApiClient(cookies).get(url)
    .then(response => response.data);
}

export async function createCubeTestReport(cookies, inputs) {
  return getApiClient(cookies).post(`${apiBaseUrl}/cube_test_report/`, inputs)
}

export async function getAllCubeTestReports(cookies, options = {}) {
  const params = { ...options };
  if (params.to_date && !params.upto_date) {
    params.upto_date = params.to_date;
    delete params.to_date;
  }
  const url = appendQueryParams(`${apiBaseUrl}/cube_test_report/`, params);
  return getApiClient(cookies).get(url)
    .then(response => response.data);
}

export async function printCubeTestReport(cookies, ctrId) {
  return getApiClient(cookies).get(
    `${apiBaseUrl}/cube_test_report/${ctrId}/print_cube_test_report/`,
    { responseType: 'blob' }
  ).then((response) => response.data);
}

export async function getCubeTestReportDetails(cookies, ctrId) {
  return getApiClient(cookies)
    .get(`${apiBaseUrl}/cube_test_report/${ctrId}/`)
    .then(response => response.data);
}

export function deleteCubeTestReport(cookies, ctrId) {
  return getApiClient(cookies).delete(`${apiBaseUrl}/cube_test_report/${ctrId}/`);
}

export function cancelCubeTestReport(cookies, ctrId) {
  return getApiClient(cookies).patch(`${apiBaseUrl}/cube_test_report/${ctrId}/`)
}

export function updateCubeTestReport(cookies, inputs, ctrId) {
  return getApiClient(cookies).put(`${apiBaseUrl}/cube_test_report/${ctrId}/`, inputs)
}
